import styled, { css, keyframes } from 'styled-components';
import * as RadixContextMenu from '@radix-ui/react-context-menu';

export const DropdownMenu = RadixContextMenu.Root;
export const DropdownMenuTrigger = RadixContextMenu.Trigger;

const slideUpAndFade = keyframes`
    from {
        opacity: 0;
        transform: translateY(2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const slideRightAndFade = keyframes`
    from {
        opacity: 0;
        transform: translateX(-2px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

const slideDownAndFade = keyframes`
    from {
        opacity: 0;
        transform: translateY(-2px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const slideLeftAndFade = keyframes`
    from {
        opacity: 0;
        transform: translateX(2px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`;

export const contextMenuContentStyles = () => css`
    box-sizing: border-box;

    box-shadow: 0 10px 38px -10px rgba(22, 23, 24, 0.35), 0 10px 20px -15px rgba(22, 23, 24, 0.2);
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    z-index: 9999;
    min-width: 220px;
    padding: 6px 0;
    flex-direction: column;
    border-radius: 8px;
    background: ${props => props.theme.root.colors.background['02Second']};
    list-style: none;
    box-sizing: border-box;

    &[data-state='open'] {
        &[data-side='top'] {
            animation-name: ${slideDownAndFade};
        }
        &[data-side='right'] {
            animation-name: ${slideLeftAndFade};
        }
        &[data-side='bottom'] {
            animation-name: ${slideUpAndFade};
        }
        &[data-side='left'] {
            animation-name: ${slideRightAndFade};
        }
    }
`;

export const ContextMenuContent = styled(RadixContextMenu.Content)`
    ${contextMenuContentStyles()}
`;

export const ContextMenuSubContent = styled(RadixContextMenu.SubContent)<{ $maxHeight?: number }>`
    ${contextMenuContentStyles()}
    max-height: ${({ $maxHeight }) =>
        $maxHeight
            ? `min(${$maxHeight}px, var(--radix-context-menu-content-available-height))`
            : 'var(--radix-context-menu-content-available-height)'};
    overflow-y: auto;
`;

export const ContextMenuItem = styled(RadixContextMenu.Item)`
    padding: 8px 16px;
    outline: none;
    cursor: pointer;
    user-select: none;

    &[data-highlighted] {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &:hover {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &[data-disabled] {
        pointer-events: none;
        opacity: 0.5;
    }
`;

export const ContextMenuSubTrigger = styled(RadixContextMenu.SubTrigger)`
    padding: 8px 16px;
    outline: none;
    cursor: pointer;
    user-select: none;

    &[data-highlighted],
    &[data-state='open'] {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &:hover {
        background: ${props => props.theme.root.colors.basicColors['4%']};
    }

    &[data-disabled] {
        pointer-events: none;
        opacity: 0.5;
    }
`;

export const Overlay = styled.div<{
    rect: DOMRect;
}>`
    position: fixed;
    top: ${({ rect }) => `${rect.top}px`};
    left: ${({ rect }) => `${rect.left}px`};
    width: ${({ rect }) => `${rect.width}px`};
    height: ${({ rect }) => `${rect.height}px`};
    pointer-events: auto;
    z-index: 999;
`;
